export const isObject = item => item && typeof item === 'object';

const UNSAFE_MERGE_KEYS = new Set(['__proto__', 'constructor', 'prototype']);

export const deepMerge = (target, source) => {
    const output = { ...target };
    if (isObject(target) && isObject(source)) {
        Object.keys(source).forEach(key => {
            if (UNSAFE_MERGE_KEYS.has(key)) return;
            if (isObject(source[key])) {
                if (!(key in target)) {
                    Object.assign(output, { [key]: source[key] });
                } else {
                    output[key] = deepMerge(target[key], source[key]);
                }
            } else {
                Object.assign(output, { [key]: source[key] });
            }
        });
    }
    return output;
};
